// extracted by mini-css-extract-plugin
export var logo = "branding-module--logo--1KJAM";
export var logoPrimary = "branding-module--logoPrimary--3Smep";
export var logoSecondary = "branding-module--logoSecondary--3NJMp";